export default __webpack_public_path__ + "static/media/Medeata200blue.2894087d.svg";